document.addEventListener('DOMContentLoaded', function () {
document.getElementById('custom_chat_btn').addEventListener('click', function () {
    // Assuming Tidio's API is loaded
    if (window.tidioChatApi) {
        tidioChatApi.open(); // Opens the Tidio chat widget
    } else {
        console.error('Tidio Chat API not loaded.');
    }
});
});

document.addEventListener('DOMContentLoaded', function () {
document.addEventListener('scroll', function () {
    const scrollThreshold = window.innerHeight * 0.2; // 20% of viewport height
    const stickyCheckout = document.querySelector('.sticky-checkout');

    if (window.scrollY > scrollThreshold) {
        stickyCheckout.classList.add('active'); // Add class when scroll passes the threshold
    } else {
        stickyCheckout.classList.remove('active'); // Remove class when back above the threshold
    }
});
});
